export default {"src":"/_next/static/media/resize.8633b17c.svg","height":20,"width":20};